<template>
    <app-cmp-tabs default="content" v-if="this.element">
        <div class="flex" slot-scope="{ toggle, active }">
            <app-cmp-tabs-trigger name="content" :handle-click="toggle" :active="active">
                <i class="fal fa-file-alt"></i>Content
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="box" :handle-click="toggle" :active="active">
                <i class="fal fa-th-large"></i>Box Model
            </app-cmp-tabs-trigger>
            <app-cmp-tabs-trigger name="design" :handle-click="toggle" :active="active">
                <i class="fal fa-pencil-alt"></i>Design
            </app-cmp-tabs-trigger>
        </div>
        <div slot="items" slot-scope="{ active }">
            <app-cmp-tabs-content name="content" :active="active">
                <!-- <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                    <div class="w-1/2">
                        <label class="text-xs text-grey-darker">
                            Tyre Profile i.e. 205/55 R16 91V Tyres
                        </label>
                    </div>
                    <div class="w-1/2 text-right">
                        <app-field-text
                            class="reset"
                            :classes="{ input: { 'input--composer': true } }"
                            name="alt"
                            placeholder=""
                            v-model="element.object.values.tyre_profile"
                        />
                    </div>
                </div> -->

                <div class="bg-white p-4 font-bold text-sm" style="border-top: 1px solid #d3d3d3; border-bottom: 1px solid #d3d3d3;">
                    Tyres
                </div>
                <app-draggable :list="element.object.values.slides" class="p-4" :options="{draggable:'.draggable', handle:'.draggable'}" v-if="element.object.values.slides.length > 0">
                    <app-collapseable-box
                        v-for="(item, index) in element.object.values.slides"
                        class="draggable mb-4"
                        :key="index"
                        :index="index"
                        @remove="remove"
                    >
                        <div slot="header" class="flex items-center justify-between">
                            <div>
                                <h4 v-html="`Tyre - ${element.object.values.slides[index].profile} - ${element.object.values.slides[index].title} `" />
                            </div>
                            <div v-if="removeable" class="cursor-pointer z-20 p-1" @click="remove(index)">
                                <app-icon icon="times" class="text-red text-sm" />
                            </div>
                        </div>

                        <div class="flex flex-wrap items-center px-6 py-4">
                            <div class="w-1/2">
                                <label class="text-xs text-grey-darker">
                                    Disable?
                                </label>
                            </div>
                            <div class="w-1/2 text-right">
                                <app-toggle-field
                                    :required="false"
                                    class="reset"
                                    :classes="{ input: { 'input--composer': true } }"
                                    v-model="element.object.values.slides[index].disable"
                                />
                            </div>
                        </div>

                        <app-field-text
                            label="Profile"
                            v-model="element.object.values.slides[index].profile"
                        />

                        <app-field-text
                            label="Title"
                            v-model="element.object.values.slides[index].title"
                        />

                        <app-field-text
                            label="Subtitle"
                            v-model="element.object.values.slides[index].subtitle"
                        />

                        <app-field-text
                            label="Tyre spec"
                            v-model="element.object.values.slides[index].tyre_spec"
                        />

                        <app-field-text
                            label="Wet grip"
                            v-model="element.object.values.slides[index].wet_grip"
                        />

                        <app-field-text
                            label="Fuel efficiency"
                            v-model="element.object.values.slides[index].fuel_eff"
                        />

                        <app-field-text
                            label="Noise rating"
                            v-model="element.object.values.slides[index].noise_rating"
                        />

                        <app-cmp-trix-field
                            label="Description"
                            :classes="{ wrapper: { 'reset': false } }"
                            v-model="element.object.values.slides[index].description"
                        />

                        <app-field-text
                            label="Pricing Total"
                            v-model="element.object.values.slides[index].price"
                        />

                        <div class="flex flex-wrap items-center px-6 py-4" style="border-bottom: 1px solid rgb(211, 211, 211);">
                            <div class="w-1/2">
                                <label class="text-xs text-grey-darker">
                                    Tyre quality
                                </label>
                            </div>
                            <div class="w-1/2 text-right">
                                <app-field-select class="reset" :classes="{ input: { 'input--composer': true } }" :items="fields.tyre_quality.options" v-model="element.object.values.slides[index].tyre_quality" />
                            </div>
                        </div>

                        <div>
                            <label class="text-xs">
                                Brand logo
                            </label>
                            <app-field-file
                                class="mt-2"
                                v-model="element.object.values.slides[index].logo"
                                :types="{images: true, files: false}"
                            />
                        </div>

                        <div>
                            <label class="text-xs">
                                Image
                            </label>
                            <app-field-file
                                class="mt-2"
                                v-model="element.object.values.slides[index].image"
                                :types="{images: true, files: false}"
                            />
                        </div>

                        <app-field-text
                            label="Image Alt"
                            v-model="element.object.values.slides[index].alt"
                        /> 

                    </app-collapseable-box>
                </app-draggable>
                <p v-else class="p-4 text-sm">
                    There are currently no slides.
                </p>

                <div class="px-4 text-right w-full mb-8">
                    <app-button element="a" class="btn  btn--primary  btn--primary--sml" @click="add">
                        Add
                    </app-button>
                </div>
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="box" :active="active">
                <app-cmp-box-model
                    :element="element.object"
                />

                <app-cmp-border
                    :element="element.object"
                />
            </app-cmp-tabs-content>
            <app-cmp-tabs-content name="design" :active="active">
                <app-cmp-design
                    :element="element.object"
                />
            </app-cmp-tabs-content>
        </div>
    </app-cmp-tabs>
</template>

<script>
    import Api from '@/api/index.js';
    
    import CmpTabs from '@/components/composer/Tabs/Tabs';
    import CmpTabsTrigger from '@/components/composer/Tabs/TabsTrigger';
    import CmpTabsContent from '@/components/composer/Tabs/TabsContent';

    import Button from '@/components/Button';
    import CollapseableBox from '@/components/CollapseableBox';

    import ColourField from '@/components/fields/inputs/Colour';
    import TextField from '@/components/fields/inputs/Text';
    import ToggleField from '@/components/fields/inputs/Toggle';
    import FileField from '@/components/fields/inputs/File';
    import SelectField from '@/components/fields/inputs/Select';
    import ComposerTrixField from '@/components/composer/Fields/Trix';

    import CmpBoxModel from '@/components/composer/Forms/Partials/BoxModel';
    import CmpBorder from '@/components/composer/Forms/Partials/Border';
    import CmpDesign from '@/components/composer/Forms/Partials/Design';

    import draggable from 'vuedraggable';

    export default {
        components: {
            'app-draggable': draggable,
            'app-button': Button,
            'app-collapseable-box': CollapseableBox,
            'app-cmp-tabs': CmpTabs,
            'app-cmp-tabs-trigger': CmpTabsTrigger,
            'app-cmp-tabs-content': CmpTabsContent,
            'app-cmp-box-model': CmpBoxModel,
            'app-cmp-border': CmpBorder,
            'app-cmp-design': CmpDesign,
            'app-field-text': TextField,
            'app-colour-field': ColourField,
            'app-toggle-field': ToggleField,
            'app-field-file': FileField,
            'app-field-select': SelectField,
            'app-cmp-trix-field': ComposerTrixField,
        },
        props: {
            element: {
                type: Object,
                required: true
            },
            removeable: {
                type: Boolean,
                required: false,
                default: true
            }
        },

        data: () => ({
            fields: {
                text: {
                    name: 'Text',
                    attribute: 'text'
                },
                tyre_quality: {
                    name: 'Tyre quality',
                    attribute: 'tyre_quality',
                    options: [
                        {
                            value: 1,
                            label: 'Best',
                        },
                        {
                            value: 2,
                            label: 'Better',
                        },
                        {
                            value: 3,
                            label: 'Good',
                        },
                    ]
                },
            }
        }),

        // created() {
        //     // Get all locations
        //     return Api.request('get', `locations/locations?filterForWebsite=true`)
        //         .then(({ data }) => {
        //             // Push all locations to 'fields.locations', so we can use this to check and create each slides locations for initial instance
        //             data.locations.forEach((location, index) => {
        //                 location['checked'] = false;
        //                 this.fields.locations.options.push(location);
        //             });
                    
        //             // Loop through each slide and check if locations is defined - this is to prevent errors as they won't exist initially
        //             this.element.object.values.slides.forEach((slide, index) => {
        //                 if (typeof this.element.object.values.slides[index].locations == 'undefined') {
        //                     this.$set(this.element.object.values.slides[index], 'locations', JSON.parse(JSON.stringify(this.fields.locations)));
        //                 }
        //             });
        //         });
        // },

        methods: {
            add() {
                this.element.object.values.slides.push({
                    'disable': false,
                    'profile': '',
                    'title': '',
                    'subtitle': '',
                    'tyre_spec': '',
                    'tyre_spec': '',
                    'wet_grip': '',
                    'fuel_eff': '',
                    'noise_rating': '',
                    'price': '',
                    'tyre_quality': 'best',
                    'logo': null,
                    'image': null,
                    'alt': ''
                });
            },

            remove(index) {
                this.element.object.values.slides.splice(index, 1);
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/composer/Elements/TyreSettings.vue